export const updateMSTObject = (self, data) => {
  Object.keys(data).forEach(key => {
    if (key === 'id' || data[key] === undefined) return;
    self[key] = data[key];
  });
};
